import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasSearchShortcutSelected.meta';

export type UseTrackCanvasSearchShortcutSelectedParams = {
  action_taken: 'suggestion_selected' | 'search_submitted';
  search_term: string;
};

export const useTrackCanvasSearchShortcutSelected = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasSearchShortcutSelected = useCallback(
    (params: UseTrackCanvasSearchShortcutSelectedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasSearchShortcutSelected };
};
